<template>
    <transition name="fade">
        <div v-if="visible" class="v-loading" :class="{ 'is-fullscreen': fullscreen }" :style="wrapStyle">
            <div class="v-loading__mask" v-if="fullscreen"></div>
            <div class="v-loading__spinner">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" />
                </svg>
                <p v-if="text" class="v-loading__text">{{ text }}</p>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        text: {
            type: String,
            default: '加载中...'
        },
        fullscreen: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        wrapStyle() {
            return this.fullscreen
                ? { position: 'fixed', zIndex: 9999 }
                : {}
        }
    }
}
</script>

<style scoped>
.v-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.v-loading__mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.v-loading__spinner {
    position: relative;
    z-index: 1;
    text-align: center;
    color: #409eff;
}

.circular {
    width: 40px;
    height: 40px;
    animation: rotate 2s linear infinite;
}

.path {
    stroke: currentColor;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
    }
    100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
    }
}

.v-loading__text {
    margin-top: 8px;
    font-size: 14px;
    color: #fff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>